import { getBaseUrl } from '@shared';

export function clientUserSignInLinkByEmail(clientEmail?: string): string {
  return `${getBaseUrl()}/client/home?client_sign_in=true${
    clientEmail ? `&login_hint=${encodeURIComponent(clientEmail)}` : ''
  }`;
}
